module.exports = __webpack_public_path__ + "img/desktop_2.0affc22a.png";